import React from 'react';
// Fonts are served from this site (no request to Google): Open Sans 300/400/600/700
// and Roboto 300/400/500/700, normal style, the same weights the pages used before.
import '@fontsource/open-sans/300';
import '@fontsource/open-sans/400';
import '@fontsource/open-sans/600';
import '@fontsource/open-sans/700';
import '@fontsource/roboto/300';
import '@fontsource/roboto/400';
import '@fontsource/roboto/500';
import '@fontsource/roboto/700';
import CookieBanner from './src/common/components/CookieBanner';
import { read, loadHotjar, loadGa4 } from './src/common/consent';
import { registerCloudPouchTools } from './src/webmcp';
import { keepAnchorInView } from './src/common/utils/keepAnchorInView';
import { installCampaignCarrier } from './src/common/utils/campaign';

const hashId = () => decodeURIComponent(window.location.hash.slice(1));

export const onClientEntry = () => {
  const consent = read();
  if (consent && consent.analytics) {
    loadHotjar();
    loadGa4();
  }
  registerCloudPouchTools();
  // native #anchor links (logo, "See Free vs Pro", /#pricing on the home page)
  window.addEventListener('hashchange', () => keepAnchorInView(hashId()));
};

// Landing on /#section: Gatsby may restore an older scroll position of the page
// after the browser's own jump, so put the section back in view once mounted.
export const onInitialClientRender = () => {
  keepAnchorInView(hashId());
  // After hydration, so React never sees the links with the tags added.
  installCampaignCarrier();
};

// The banner comes first in the DOM, so keyboard users reach it first.
export const wrapPageElement = ({ element }) => (
  <>
    <CookieBanner />
    {element}
  </>
);
